import { render, staticRenderFns } from "./RequestConfirmationCard.vue?vue&type=template&id=5d1afe2d&scoped=true"
import script from "./RequestConfirmationCard.vue?vue&type=script&lang=ts"
export * from "./RequestConfirmationCard.vue?vue&type=script&lang=ts"
import style0 from "./RequestConfirmationCard.vue?vue&type=style&index=0&id=5d1afe2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1afe2d",
  null
  
)

export default component.exports